import getPathToRedirectLoggedInUser from '@/mixins/getPathToRedirectLoggedInUser'
import store from '@/store'
import { PostcodeData } from '@/store/booking-funnel/postcode/types'
import { CarePlan } from '@/store/defintions/types'
import MissionControl from '@/sdk/missionControl'
import logger from '@/sdk/logger'

export const CP_SOURCE_QUERY_PARAM = 'cpSourceQueryParam'

async function getCaregiversByPostcodeCount(postcode): Promise<number> {
  await store.dispatch('postcode/fetchPostcodeData', postcode)

  const postcodeData: PostcodeData = store.getters['postcode/getPostcodeData'](
    postcode,
  )

  store.dispatch('postcode/setMapData', {
    postcode: postcodeData.postcode,
    lat: postcodeData.location.lat,
    lng: postcodeData.location.lng,
  })

  await store.dispatch('registration/getCaregiversListByPostcode', postcode)

  return store.getters['registration/caregiversByPostcodeCount']
}

function isCarePlanAvailable(carePlanId: string): boolean {
  const activeCarePlans: CarePlan[] =
    store.getters['definitions/activeCarePlans']

  return activeCarePlans.some(({ id }) => id === carePlanId)
}

type AvailableCarePlansParams = Array<{ param: string; care_plan_id: string }>

function getAvailableCarePlansParams(): AvailableCarePlansParams | undefined {
  try {
    const carePlanParams = MissionControl.get(
      'care_plans.funnel_params_to_care_plans',
    )

    if (!carePlanParams || typeof carePlanParams.value !== 'string') {
      return
    }

    const parsedCarePlanParams = JSON.parse(carePlanParams.value)

    const hasInvalidCarePlanParams = parsedCarePlanParams.some(
      cpp => cpp && !(cpp.param && cpp.care_plan_id),
    )

    if (hasInvalidCarePlanParams) {
      logger.error(
        'invalid prop names in care plans params from mission control',
        {
          tags: ['registration', 'carePlan'],
          error: new Error('parse error'),
        },
      )

      return
    }

    return parsedCarePlanParams
  } catch (error) {
    logger.error('error while getting care plans params from mission control', {
      tags: ['registration', 'carePlan'],
      error,
    })
  }
}

export function mapCpSourceQueryParamToCarePlanId(
  cpSource?: string,
): string | undefined {
  const availableCarePlansParams = getAvailableCarePlansParams()

  if (!availableCarePlansParams) {
    return
  }

  const validCarePlanEntry = availableCarePlansParams.find(
    ({ param }) => param === cpSource,
  )

  if (!validCarePlanEntry) {
    return
  }

  const carePlanId = validCarePlanEntry.care_plan_id
  const isCarePlanValid = isCarePlanAvailable(carePlanId)

  if (!isCarePlanValid) {
    return
  }

  return carePlanId
}

async function handleCarePlanQueryParam(carePlanId: string) {
  if (!carePlanId || !MissionControl.isFeatureEnabled('enable.care_plans')) {
    return
  }

  if (!isCarePlanAvailable(carePlanId)) {
    return
  }

  await store.dispatch('services/setCarePlan', carePlanId)
}

async function handleCpSourceQueryParam(cpSource: string) {
  if (!cpSource) {
    return
  }

  localStorage.setItem(CP_SOURCE_QUERY_PARAM, cpSource)

  const carePlanId = mapCpSourceQueryParamToCarePlanId(cpSource)

  if (!carePlanId) {
    return
  }

  await store.dispatch('services/setCarePlan', carePlanId)
}

export default async (to, from, next) => {
  const postcode = to.query.postcode || store.getters['postcode/postcode']

  const postcodeData: PostcodeData = store.getters['postcode/getPostcodeData'](
    postcode,
  )

  await store.dispatch('services/clearCarePlan')

  await handleCarePlanQueryParam(to.query.carePlan)

  await handleCpSourceQueryParam(to.query.cpSource)

  switch (true) {
    case Boolean(store.getters['auth/isAuthenticated']()):
      next(await getPathToRedirectLoggedInUser())
      break

    case Boolean(postcode):
      try {
        const caregiversCount = await getCaregiversByPostcodeCount(postcode)
        const postcodeData: PostcodeData = store.getters['postcode/getPostcodeData'](
          postcode,
        )

        if(postcodeData.city){
          next('/anfrage/registrieren'+window.location.search)
          break
        }

      } catch (error) {
        window.location.href = '/'
        break
      }

    default:
      // next('/anfrage')
      break
  }
}
